import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface BreadcrumbPortalProps {
  children: ReactNode;
}

/**
 * BreadcrumbPortal renders breadcrumb content into the header breadcrumb slot.
 * Use this to display page-specific breadcrumbs.
 *
 * Example:
 * <BreadcrumbPortal>
 *   <span className="text-sm px-1">Cases</span>
 * </BreadcrumbPortal>
 */
export function BreadcrumbPortal({ children }: BreadcrumbPortalProps) {
  const portalRoot =
    typeof document !== 'undefined' ? document.getElementById('breadcrumb-portal-root') : null;

  if (!portalRoot) {
    return null;
  }

  return createPortal(children, portalRoot);
}
